<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.reports'), $t('reports.mesQa')]">
      </breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
        label-width="110px"
      >
        <el-form-item
          :label="$t('reportQa.endAt')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.date')]),
              trigger: 'blur',
            },
          ]"
        >
          <date-range
            v-model="searchForm"
            type="datetime"
            field="checkAt"
            :start-placeholder="$t('text.startAt')"
            :end-placeholder="$t('text.endAt')"
          />
        </el-form-item>
        <br />
        <el-form-item :label="$t('menu.factories')">
          <el-checkbox-group v-model="searchForm.factoryIds">
            <el-checkbox
              v-for="(factory, index) of mesAuthFactories"
              :key="index"
              :label="factory.id"
              >{{ factory.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <br />
        <el-form-item
          :label="$t('workOrder.checkerName')"
          v-if="users.length != 0"
        >
          <el-checkbox-group v-model="searchForm.checkerIds">
            <el-checkbox v-for="user of users" :key="user.id" :label="user.id">
              <span v-if="user.voidAt != null" class="deleted">
                {{ user.name }}
              </span>
              <span v-else>{{ user.name }}</span>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <br v-if="users.length != 0" />
        <el-form-item :label="' '">
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            >{{ $t("text.search") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="default" size="mini" @click="download">
              {{ $t("action.download") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="workOrderSerialNo"
          :title="$t('workOrder.serialNo')"
          min-width="100px"
        />
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100px"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="customerName"
          :title="$t('menu.customers')"
          min-width="100px"
        />
        <vxe-table-column
          field="workflowState"
          :title="$t('text.workflowState')"
          min-width="100px"
        >
          <template v-slot="{ row }">
            {{ $t("workOrderStates." + row.workflowState) }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="factoryName"
          :title="$t('menu.factories')"
          min-width="100px"
        />
        <vxe-table-column
          field="checkerName"
          :title="$t('workOrder.checkerName')"
          min-width="100px"
        />
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          min-width="100px"
        />
        <vxe-table-column
          field="checkStartAt"
          :title="$t('reportQa.startAt')"
          min-width="110px"
        />
        <vxe-table-column
          field="checkEndAt"
          :title="$t('reportQa.endAt')"
          min-width="110px"
        />
        <vxe-table-column
          field="checkQuantity"
          :title="$t('workOrder.qaQuantity')"
          min-width="80px"
        />
        <vxe-table-column
          field="workOrderRemark"
          :title="$t('text.remark')"
          min-width="100px"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.workOrderRemark"
              :number="12"
              type="richText"
            />
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils";
import DateRange from "@/components/DateRange";
import Factory from "@/api/factory";
import UserFactory from "@/api/userFactory";
import User from "@/api/user";
import Qa from "@/api/qa";

export default {
  mixins: [page, table.search],
  components: { DateRange },
  data() {
    return {
      searchForm: {
        checkAtStartAt: null,
        checkAtEndAt: null,
        factoryIds: [],
        checkerIds: [],
      },
      mesAuthFactories: [],
      users: [],

      searchDoing: false,
      records: [],
      total: [],
      records: [],
      loading: false,
    };
  },

  created() {
    const self = this;
    axios
      .all([
        Factory.findByTenantId(),
        // UserFactory.findByUserId(self.Permit.currentUser().id),
        User.findByTenantId(),
      ])
      .then(
        axios.spread(function (factories, users) {
          self.mesAuthFactories = factories.data;
          // const userFactories = [];
          // if (userFactory.data.length !== 0) {
          //   for (const u of userFactory.data) {
          //     if (
          //       factoriesAll.find((allf) => allf.id === u.factoryId) != null
          //     ) {
          //       userFactories.push(
          //         factoriesAll.find((allf) => allf.id === u.factoryId)
          //       );
          //     }
          //   }
          // }
          // if (self.Permit.currentUser().admin === true) {
          //   self.mesAuthFactories = factoriesAll;
          // } else {
          //   self.mesAuthFactories = userFactories;
          // }
          //
          self.users = users.data.filter(
            (u) => (u.voidAt == null && u.authorize == true) || u.voidAt != null
          );
          // if (self.Permit.currentUser().admin === true) {
          //   self.users = allUsers;
          // } else {
          //   self.users = allUsers.filter((u) =>
          //     JSON.parse(self.Permit.currentUser().manageUsers).includes(u.id)
          //   );
          // }
        })
      );
  },
  methods: {
    search() {
      const self = this;
      if (self.searchForm.checkAtStartAt == null) {
        this.$message({
          message: self.$t("rules.select", [self.$t("reportQa.endAt")]),
          type: "warning",
        });
        return;
      }
      self.loading = true;
      Qa.qaReport(Util.deleteObjValueIsNull(self.searchForm)).then(function (
        res
      ) {
        self.loading = false;
        if (res.status === 200) {
          self.records = res.data;
        } else {
          self.sysError();
        }
      });
    },

    download() {
      const self = this;
      if (self.searchForm.checkAtStartAt == null) {
        this.$message({
          message: self.$t("rules.select", [self.$t("reportQa.endAt")]),
          type: "warning",
        });
        return;
      }
      if (self.records.length == 0) {
        this.$message({
          message: self.$t("text.noData"),
          type: "warning",
        });
        return;
      }
      Qa.exportExcelQaReport(Util.deleteObjValueIsNull(self.searchForm)).then(
        function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.downloadPrompt"),
              type: "success",
            });
            self.checkedRows = [];
            self.$eventHub.$emit("emitDownLoad");
          } else {
            self.$message.error(self.$t("prompt.downloadErr"));
          }
        }
      );
    },
  },
};
</script>
<style >
.el-form-item__content {
  height: auto !important;
}
</style>